<!--
 * @Description:
-->
<template>
  <el-popover placement="right" trigger="hover">
    <!-- <el-button slot="reference">项目统计</el-button> -->
    <div>
      <el-table
        :data="projectDataTable"
        style="width: 100%"
        :fit="true"
        border
        header-row-class-name="tableHeader"
      >
        <el-table-column
          header-align="center"
          prop="projectName"
          label="项目名称"
          width="180"
        ></el-table-column>
        <el-table-column header-align="center" label="金额">
          <template slot-scope="scope">
            <p>{{ scope.row.totalPrice | moneyFixed }}</p>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          prop="peopleCount"
          label="支付人数"
        ></el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <div
      slot="reference"
      style="margin-left:10px;background-color:#FF6600;padding:0;height:30px;padding:0 5px;line-height:30px;color:#FFFFFF;border-radius:3px"
    >
      项目统计
    </div>
  </el-popover>
</template>

<script>
import { csoCustomerOrder } from '@/api/ajax.js';
export default {
  props: [
    'orderId',
    'type',
    'csoCustomOrderSupplierId',
    'queryCustomOrderInfo',
    'csoCustomOrderIds'
  ],
  data() {
    return {
      projectDataTable: [],
      pageNo: 1,
      pageSize: 3,
      total: 0
    };
  },
  computed: {},
  mounted() {
    this.getQueryCustomOrderInfo();
  },
  methods: {
    handleCurrentChange(value) {
      this.pageNo = value;
      this.getQueryCustomOrderInfo();
    },
    getQueryCustomOrderInfo() {
      csoCustomerOrder
        .queryCustomOrderInfo({
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          orderStatus: (this.type || !this.type) < 4 ? 1 : 2,
          csoCustomOrderSupplierId: this.csoCustomOrderSupplierId,
          csoCustomOrderIds: this.csoCustomOrderIds
        })
        .then(result => {
          this.projectDataTable = result.data.data.list;
          this.total = result.data.data.total;
        });
    }
  }
};
</script>

<style lang="scss">
.tableHeader th {
  // color: red !important;
  font-weight: 800;
  background-color: #fbfbfb !important;
}
</style>
